import { render, staticRenderFns } from "./csv.vue?vue&type=template&id=981a94da&scoped=true&"
import script from "./csv.vue?vue&type=script&lang=js&"
export * from "./csv.vue?vue&type=script&lang=js&"
import style0 from "./csv.vue?vue&type=style&index=0&id=981a94da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981a94da",
  null
  
)

export default component.exports